import { useEffect } from "react";

export function useJsonLd(data) {
  const serialized = data ? JSON.stringify(data) : null;
  useEffect(() => {
    if (!serialized) return;
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.id = "jsonld-page";
    el.text = serialized;
    document.head.appendChild(el);
    return () => {
      document.getElementById("jsonld-page")?.remove();
    };
  }, [serialized]);
}
